import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/redux/createAction';
import { PageDecorator } from 'src/app/decorators/PageDecorator';
import { actionsCompany } from 'src/pages/CompanyPage/_BLL/slice';
import { Preloader } from 'src/shared/ui/_loaders/Preloader';
import { CompanyForm } from './ui/CompanyForm/CompanyForm';
import { CompanyFormContextProvider } from './lib/context/useCompanyPageContext';

export const CompanyPage: React.FC = () => {
	// * Selectors
	const companyMeta = useAppSelector((state) => state.company.meta);
	const menuItems = useAppSelector((state) => state.company.menuItems);
	const currentCompany = useAppSelector((state) => state.company.company);

	// * Actions
	const dispatch = useAppDispatch();
	const { getMeta, getCompany } = actionsCompany;

	// * Router
	const { companyId } = useParams<{ companyId: string }>();

	// * conditions
	const menuItemsLoaded = menuItems;

	const companyReady = companyMeta && menuItemsLoaded && currentCompany;

	// * Load meta
	useEffect(() => {
		if (!companyMeta) {
			dispatch(getMeta());
		}
	}, []);

	// * Load company
	useEffect(() => {
		if (companyId) {
			dispatch(
				getCompany({
					id: companyId,
				}),
			);
		}
	}, []);

	// * Render
	return (
		<PageDecorator>
			{companyReady ? (
				<CompanyFormContextProvider
					currentCompany={currentCompany}
					companyMeta={companyMeta}
				>
					<CompanyForm />
				</CompanyFormContextProvider>
			) : (
				<Preloader />
			)}
		</PageDecorator>
	);
};
